import React, { Component } from 'react';
import PropTypes from 'prop-types';
import ParadigmaModal from "../../../components/ParadigmaModal/ParadigmaModal.js"
import api from "../../../api";

class Modal extends Component {
    constructor(props) {
        super(props);
        this.state = {
            mostrarSaldoPendiente: true,
            errors: [],
        };
    }

    static propTypes = {
        onSubmit: PropTypes.func,
    }

    resetForm() {
        this.setState({
            mostrarSaldoPendiente: true,
            errors: [],
        });
    }

    getData() {
        const { 
            mostrarSaldoPendiente,
        } = this.state;

        let data = {
            mostrar_saldo_pendiente: Boolean(mostrarSaldoPendiente),
        };

        return data;
    }

    normalizeBoolean(value) {
        return value === true || value === 1 || value === '1' || value === 'true';
    }

    setData(data) {
        if (data.success) {
            this.setState({
                mostrarSaldoPendiente: this.normalizeBoolean(data.mostrar_saldo_pendiente),
            });
        }
    }

    setErrors(errors) {
        this.setState({
            errors: errors,
        });
    }

    onChangeField(field, value) {
        this.setState(prevState => {
            let errors = prevState.errors;
            if (errors) errors[field] = null;
            prevState.errors = errors;
            prevState[field] = value;
            return prevState;
        });
    }

    getError(field) {
        let errors = this.state.errors;
        if (errors) return errors[field];
            else return null;
    }
    
    onChangeMostrarSaldoPendiente = () => {
        this.setState(prevState => ({ 
            mostrarSaldoPendiente: !Boolean(prevState.mostrarSaldoPendiente)
        }))
    }

    render() {
        const {
            mostrarSaldoPendiente
        } = this.state;

        return (
            <ParadigmaModal
                getUrl={api.recibos.configuracion}
                submitUrl={api.recibos.configuracion}
                submitType="PUT"

                onGotData={data => this.setData(data)}
                onGotErrors={errors => this.setErrors(errors)}
                onClose={_ => this.resetForm()}
                onPreSubmit={_ => this.getData()}
                onSubmit={() => {}}

                title="Configuración de Recibos"
                className="ui-paradigma-modal"

                successMessage="La Configuración ha sido editada con éxito."
                missingIdMessage="Debe seleccionar una fila."
                saveButtonLabel="Guardar"
                buttonTitle="Configuración"
                buttonIcon="fa fa-pencil fa-lg"
                saveButton={true}
                closeButton={true}

                // Para que no se vea el modal como boton
                navButton
                nav={this.props.nav}
            >
                <section className="ui-modal-section">
                    <p className="ui-section-label">Opciones del recibo</p>
                    <div className="ui-toggle-row">
                        <button
                            type="button"
                            className={"ui-toggle-button" + (mostrarSaldoPendiente ? " is-active" : "")}
                            aria-pressed={mostrarSaldoPendiente}
                            aria-label="Mostrar saldo pendiente"
                            onClick={this.onChangeMostrarSaldoPendiente}
                        >
                            <span className="ui-toggle-handle" />
                        </button>
                        <span className="ui-toggle-label">
                            Mostrar saldo pendiente
                        </span>
                    </div>
                </section>
            </ParadigmaModal>
        );
    }
}

export default Modal;



// WEBPACK FOOTER //
// ./src/views/Recibos/Configuracion/Modal.js